// extracted by mini-css-extract-plugin
module.exports = {"container":"Newsletter_container__uYPzl"};